import { api } from './api';

export type ParentChild = {
  sophomorixUnid: string;
  Student_ID: number;
  Vorname: string;
  Name: string;
  Klasse: string;
};

export type ParentMessage = {
  message_id: string;
  message_type: 'email' | 'elternbrief';
  source_id: number;
  title: string;
  body_text: string | null;
  body_html: string | null;
  created_at: string;
  student_unid: string;
  beantwortet_am?: string | null;
  geoeffnet_am?: string | null;
};

export const parentApi = {
  async children(): Promise<ParentChild[]> {
    const response = await api.get('/parent/children');
    return response.data?.data || [];
  },
  async messages(): Promise<ParentMessage[]> {
    const response = await api.get('/parent/messages');
    return response.data?.data || [];
  },
  async message(messageId: string): Promise<ParentMessage> {
    const response = await api.get(`/parent/messages/${encodeURIComponent(messageId)}`);
    return response.data?.data;
  },
  async excuses(studentUnid: string) {
    const response = await api.get('/parent/excuses', {
      params: { studentUnid }
    });
    return response.data?.data || [];
  },
  async createExcuse(payload: {
    student_unid: string;
    kind: 'excuse' | 'beurlaubung' | 'sick';
    valid_from: string;
    valid_to: string;
    reason?: string;
    document_file_id?: number | null;
    excuse_date?: string | null;
    affected_periods?: Array<{ weekday?: number; period_no?: number; date?: string }> | null;
  }) {
    const response = await api.post('/parent/excuses', payload);
    return response.data?.data;
  },
  async dashboard(studentUnid: string) {
    const response = await api.get(`/parent/children/${encodeURIComponent(studentUnid)}/dashboard`);
    return response.data?.data;
  },
  async skillmap(studentUnid: string) {
    const response = await api.get(`/parent/children/${encodeURIComponent(studentUnid)}/skillmap`);
    return response.data?.data;
  },
  async evidenceTrend(studentUnid: string, params: Record<string, string>) {
    const response = await api.get(`/parent/children/${encodeURIComponent(studentUnid)}/evidence-trend`, { params });
    return response.data;
  },
  async week(studentUnid: string, from: string, to: string) {
    const response = await api.get(`/parent/children/${encodeURIComponent(studentUnid)}/klassenbuch/week`, {
      params: { from, to }
    });
    return response.data?.data || [];
  },
  async uploadExcuseFile(studentUnid: string, file: File): Promise<number | null> {
    const form = new FormData();
    form.append('file', file);
    form.append('file_type', 'private');
    form.append('category', 'excuse');
    const response = await api.post(`/student-files/${encodeURIComponent(studentUnid)}/upload`, form);
    return response.data?.data?.file_id ?? null;
  }
};
